import React from 'react'
import { useHistory } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { usePath, useResetPassword } from 'lib/core/hooks'
import { Alert, Button, EmptyContainer, Form, Spinner } from 'lib/ui'
import * as CustomerStyles from 'components/CustomerStyles'
import { ResetPasswordForm } from './components/Form'

export const ResetPassword = () => {
  const history = useHistory()
  const path = usePath()
  const { resetPassword, isFetching, status } = useResetPassword()

  return (
    <CustomerStyles.PublicLayout>
      {status === 'loading' && (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      )}

      {status !== 'loading' && (
        <CustomerStyles.Title>
          <FormattedMessage
            id='customer.account.reset.title'
          />
        </CustomerStyles.Title>
      )}

      {status === 'expired' && (
        <>
          <Alert>
            <FormattedMessage
              id='customer.account.reset.expired'
            />
          </Alert>
          <Form.Actions.Wrapper>
            <Button
              skin={Button.SKIN.OUTLINE}
              onClick={() => history.push(path.forgotPassword)}
            >
              <FormattedMessage
                id='customer.account.reset.backToForgotPassword'
              />
            </Button>
          </Form.Actions.Wrapper>
        </>
      )}

      {status === 'success' && (
        <>
          <Alert
            type='success'
          >
            <FormattedMessage
              id='customer.account.reset.success'
            />
          </Alert>
          <Form.Actions.Wrapper>
            <Button
              skin={Button.SKIN.OUTLINE}
              onClick={() => history.push(path.login)}
            >
              <FormattedMessage
                id='customer.account.reset.backToLogin'
              />
            </Button>
          </Form.Actions.Wrapper>
        </>
      )}

      {status === 'idle' && (
        <ResetPasswordForm
          onCancel={() => history.push(path.login)}
          onSubmit={(values => {
            resetPassword({ password: values.password })
          })}
          isFetching={isFetching}
        />
      )}
    </CustomerStyles.PublicLayout>
  )
}
